import React, {useEffect} from 'react';
import {Redirect, Route} from 'react-router-dom';
import urlMap from './redirectUrlMap.json';

function ExternalRedirect({to}) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

export default urlMap.map(({from, to}) => {
  // strict is required when from = to + '/', otherwise the non-strict
  // Redirect also matches the canonical URL and self-redirects forever
  const stripSlashOnly = from === `${to}/`;
  return to.startsWith('http') ? (
    <Route key={from} exact path={from} render={() => <ExternalRedirect to={to} />} />
  ) : (
    <Redirect key={from} exact strict={stripSlashOnly} from={from} to={to} />
  );
});
